import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { searchBikeAPI } from "../../Services/BikeService";
import "./SearchPage.css";

import { getBikeMakesAPI, getBikeModelsAPI, getBikeYearAPI } from "../../Services/BikeService";

import Bike from "../../Components/Bike/Bike";
import { BikeModel } from "../../Models/BikeModel"
import BikeSearch from "../../Components/Search/BikeSearch";
import BikeRequest from "../../Components/Request/BikeRequest";
import ContactUs from "../../Components/Contact/ContactUs";
import { saveBikeRequestAPI } from "../../Services/BikeRequestService";
import { saveContactUsAPI } from "../../Services/ContactUsService";
import { toast } from "react-toastify";
import Spinner from "../../Components/Spinner/Spinner";

interface Props {}

type BikeSearchFormsInputs = {
  make: string;
  model: string;
  year: string;
};

type ContactUsFormsInputs = {
  first_name: string;
  last_name: string;
  message: string;
  email: string;
};
const contactUsValidation = Yup.object().shape({
  first_name: Yup.string().required("Make is required"),
  last_name: Yup.string().required("Model is required"),
  message: Yup.string().required("Year is required"),
  email: Yup.string().required("Email is required")
});

const validation = Yup.object().shape({
  make: Yup.string().required("Make is required"),
  model: Yup.string().required("Model is required"),
  year: Yup.string().required("Year is required"),
});


const SearchPage = (props: Props) => {
    const {
      formState: { errors },
    } = useForm<BikeSearchFormsInputs>({ resolver: yupResolver(validation) });
    useForm<ContactUsFormsInputs>({ resolver: yupResolver(contactUsValidation) });
  
    const [bikeSearchResult, setBikeSearchResult] = useState<BikeModel | null>();
    const [bikeMakes, setBikeMakes] = useState<{bike_col: string}[]>([]);
    const [ modelOptionResult, setModelOptionResult] = useState<{bike_col: string}[]>([]);
    const [ yearOptionResult, setYearOptionResult] = useState<{bike_col: string}[]>([]);
    const [loading, setLoading] = useState<boolean>();

    const [ selectedMake, setSelectedMake] = useState<string>();
    
    const searchBike = async (make: string, model: string, year: string) => {
      setLoading(true);
      const result = await searchBikeAPI(make, model, year)
      setLoading(false);
      setBikeSearchResult(result);
    };

    useEffect(() => {
      const getBikeMakesInit = async () => {
        const result = await getBikeMakesAPI();
        if(result)
          setBikeMakes(result.data);
      };
      getBikeMakesInit();
    }, []);

    const getModelOptions = async (make: string) => {
      setSelectedMake(make);
      const result = await getBikeModelsAPI(make)
      if (result){
        setModelOptionResult(result.data);
      }
      else{
        setModelOptionResult([]);
      }
    };

    const getYearOptions = async (year: string) => {
      const result = await getBikeYearAPI(selectedMake!, year)
      if (result){
        setYearOptionResult(result.data);
      }
      else{
        setYearOptionResult([]);
      }
    };

    const request = async (make: string, model: string, year: string, email: string) => {
      const result = await saveBikeRequestAPI(make, model, year, email)
        .then((res) => {
          if (res){
            toast.success("Bike request submitted successfully!");
          }
        })
        .catch((e) => {
          toast.warning(e);
        });
    };
    const contactUsForm = async (first_name: string, last_name: string, message: string, email: string) => {
      const result = await saveContactUsAPI(first_name, last_name, message, email)
        .then((res) => {
          if (res){
            toast.success("Contact us submitted successfully!");
          }
        })
        .catch((e) => {
          toast.warning(e);
        });
    };

  return (
    <section className="search-page">
      <BikeSearch searchBike={ searchBike }
       getModelOptions={ getModelOptions }
       getYearOptions={ getYearOptions }
       makeOptions={bikeMakes!} modelOptions={modelOptionResult} yearOptions={yearOptionResult}/>

      {loading ? <Spinner /> : bikeSearchResult && 
        <Bike bikeModel = {bikeSearchResult!} />
      }
      <BikeRequest request={ request }/>
      <ContactUs contactRequest={ contactUsForm }/>
    </section>
  );
};

export default SearchPage;
